// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\PushNotificationTestResponse

import { UserDeviceTokenStatus } from './enums.gen';

export type PushNotificationTestApiResponse = {
	sent: boolean;
	tokenStatus: UserDeviceTokenStatus | null;
	token_status: UserDeviceTokenStatus | null;
	error: string | null;
};

export type PushNotificationTest = {
	sent: boolean;
	tokenStatus: UserDeviceTokenStatus | null;
	token_status: UserDeviceTokenStatus | null;
	error: string | null;
};

export function hydratePushNotificationTest(data: PushNotificationTestApiResponse): PushNotificationTest {
	return { ...data };
}